import React, { useState, useEffect } from 'react';
import {
  Typography,
} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBadge from "components/MKBadge";
import MKAvatar from "components/MKAvatar";
import MKButton from "components/MKButton";
import profilePicture from "assets/images/bruce-mars.jpg";
import routes from "routes";
import bgImage from "assets/images/trainer-profile.jpg";
import { useParams } from "react-router-dom";
import Logo from "assets/images/skill3.png";
import Breadcrumbs from "examples/Breadcrumbs";
import { LocationOn } from '@mui/icons-material';
import SimpleFooter from "examples/Footers/SimpleFooter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function Author() {
  const { uidb64, token, trainerID, trainingCompanyID } = useParams();
  const [trainerList, setTrainerList] = useState([]);
  const [bbdata, setbbData] = useState([]);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [socialMedia, setSocialMedia] = useState('');
  const [educationDetails, setEducationDetails] = useState('');
  const [workExperience, setWorkExperience] = useState('');
  const [personalDetails, setPersonalDetails] = useState('');
  const [personalDetailsAddress, setPersonalDetailsAddress] = useState('');
  const [personalDetailsLanguage, setPersonalDetailsLanguage] = useState('');
  const [certifications, setCertifications] = useState('');
  const [trainingExperience, setTrainingExperience] = useState('');
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-list/${trainerID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setbbData(data);
          setTrainerList(data);
          setSocialMedia(data.socialMedia);
          setEducationDetails(data.educationDetails);
          setWorkExperience(data.workExperience);
          setPersonalDetails(data.personalDetails);
          let address = data.personalDetails.address;
          setPersonalDetailsAddress(address);
          let language = data.personalDetails.languages;
          setPersonalDetailsLanguage(language);
          setCertifications(data.certifications);
          setTrainingExperience(data.trainingExperience);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("trainerList", trainerList);
  console.log("data", bbdata);

  const onAcceptClick = (e) => {
    const data = {
      uidb64: uidb64,
      token: token,
      trainingCompanyAgreeStatus: "Accept",
      trainerID: trainerID,
      trainingCompanyID: trainingCompanyID,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/redir-company-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitCompleted(true);
        } else {
          setSubmitCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const DialogProfileClose = () => {
    setShowModal(false);
    window.location.href = "/portal";
  };

  const onDeclineClick = () => {
    const data = {
      uidb64: uidb64,
      token: token,
      trainingCompanyAgreeStatus: "Decline",
      trainerID: trainerID,
      trainingCompanyID: trainingCompanyID,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/redir-company-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitCompleted(true);
        } else {
          setSubmitCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  return (
    <>
      <DefaultNavbar
        routes={routes}
      />
      <MKBox bgColor="white">
        <MKBox
          minHeight="35rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.3),
                rgba(gradients.dark.state, 0.3)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            // mt: -8,
            mb: 4,
            // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <MKBox component="section" py={{ xs: 6, sm: 12 }}>
            <Container>
              <Grid container item xs={12} justifyContent="center" mx="auto">
                <MKBox mt={{ xs: -16, md: -20 }} textAlign="center">
                  {/* <MKAvatar src={profilePicture} alt="Burce Mars" size="xxl" shadow="xl" /> */}
                  <MKAvatar
                    src={`${process.env.REACT_APP_API_URL}${trainerList .profilePictureName}/`}
                    alt="Profile Picture"
                    size="xxl"
                    style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                  />
                </MKBox>
                <Dialog
                  open={submitCompleted}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    Notification !
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Your Response has been succesfully submitted !
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <MKButton onClick={() => { setSubmitCompleted(false); DialogProfileClose(); }} color="primary" autoFocus>
                      OK
                    </MKButton>
                  </DialogActions>
                </Dialog>
                <Grid container justifyContent="center" py={6} style={{ marginTop: "-90px" }}>
                  <Grid item xs={12} md={12} mx={{ xs: "auto", sm: 6, md: 1 }}>

                    <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                      <Typography component="span" variant="body2" fontWeight="regular" color="text">
                        Review the details of the trainer, {trainerList.firstName}&nbsp;{trainerList.lastName} and decide to 'Accept' or 'Decline' their application.
                      </Typography>
                    </MKBox>

                    <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                      <Typography variant="h3">{trainerList.firstName}&nbsp;{trainerList.lastName}</Typography>
                    </MKBox>

                    <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          {trainerList.skills}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          &nbsp;|&nbsp; <LocationOn style={{ marginRight: '5px' }} />
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          {trainerList.location}
                        </Typography>
                      </Grid>
                    </MKBox>

                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Basic Details</span> }]} />
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Date of Birth :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                          {personalDetails.dob}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          Gender :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "100px" }}>
                          {personalDetails.gender}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Mode Of Training :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                          {trainerList.trainingMode}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          Total Experience :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                          {trainerList.totalExperience}&nbsp;years
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Williness to Record Training ?&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "23px" }}>
                          {trainerList.recordTraining === 'yes' ? 'Yes' : 'No'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          Differently Abled ?&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "34px" }}>
                          {trainerList.differentlyAbled === 'yes' ? 'Yes' : 'No'}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Williness to Travel Within the Country ?&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "20px" }}>
                          {trainerList.travelWithInYourCountry === 'yes' ? 'Yes' : 'No'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          Williness to Travel Outside the Country ?&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          {trainerList.travelOutSideCountry === 'yes' ? 'Yes' : 'No'}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Williness to provide Weekend Training ?&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          {trainerList.weekendTraining === 'yes' ? 'Yes' : 'No'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          Williness to provide Individual Training ?&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "17px" }}>
                          {trainerList.individualTraining === 'yes' ? 'Yes' : 'No'}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={3.5}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Working Time Zone :&nbsp;
                        </Typography>
                      </Grid>
                      <Grid item xs={7.5}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "-32px" }}>
                          {trainerList.workingTimeZone} <br />
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={3}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          About Trainer :&nbsp;
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                          {trainerList.profile} <br />
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Average Commericals (per hour)</span> }]}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          For less than 4 hours :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "27px" }}>
                          {trainerList.currency}&nbsp;{trainerList.avgCommercialForLessthan4hrs}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          For 4 hours :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "94px" }}>
                          {trainerList.currency}&nbsp;{trainerList.avgCommercialFor4hrs}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          For 8 hours :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "94px" }}>
                          {trainerList.currency}&nbsp;{trainerList.avgCommercialFor8hrs}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Training Experience</span> }]}
                        />
                      </Grid>
                    </Grid>

                    {trainingExperience && trainingExperience.map((training, index) => (
                      <div key={index}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                          <MKBadge badgeContent={`Training Profile - ${training.profileName}`} color="secondary" variant="contained" container />
                        </div>
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Technology :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "112px" }}>
                              {training.trainingTechnology}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Client Delivered :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "85px" }}>
                              {training.clientDelivered}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Training Duration :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "75px" }}>
                              {training.trainingDuration} hours
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Total Trainings Delivered :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "20px" }}>
                              {training.totalNoOfTrainings}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Date of Last Training :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "51px" }}>
                              {training.dateOfLastTraining}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Total Training Expereince :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "19px" }}>
                              {training.totalTrainingExperience} Years
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Delivery Method :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "83px" }}>
                              {training.deliveryMethod}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Demo Video Link :&nbsp;
                            </Typography>
                            {training && (
                              <a
                                href={training.demoLink.startsWith("http") ? training.demoLink : `http://${training.demoLink}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: "18px", textDecoration: "underline" }}
                              >
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "61px", textDecoration: "underline", color: "blue" }}>
                                  {training.demoLink}
                                </Typography>
                              </a>
                            )}
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={3}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Project Title :&nbsp;
                            </Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "31px" }}>
                              {training.projectTitle} <br />
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={3.5}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Project Descritption :&nbsp;
                            </Typography>
                          </Grid>
                          <Grid item xs={8.5}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                              {training.projectDescription} <br />
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Commercials For less than 4 hrs (per hour) :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "20px" }}>
                              {training.commercialsCurrency}&nbsp;{training.forLessThan4hrs}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Commercials For 4 hrs (per hour) :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "88px" }}>
                              {training.commercialsCurrency}&nbsp;{training.for4hrs}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Commercials For 8 hrs (per hour) :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "88px" }}>
                              {training.commercialsCurrency}&nbsp;{training.for8hrs}
                            </Typography>
                          </Grid>
                        </Grid>

                      </div>
                    ))}

                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Work Experience</span> }]}
                        />
                      </Grid>
                    </Grid>

                    {workExperience && workExperience.map((work, index) => (
                      <div key={index}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                          <MKBadge badgeContent={`Work Experience ${index + 1}`} color="secondary" variant="contained" container />
                        </div>
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Company Name :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "26px" }}>
                              {work.companyName}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Skills :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "104px" }}>
                              {work.technology}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Designation :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "58px" }}>
                              {work.designation}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Employment Type :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "20px" }}>
                              {work.employmentType}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Date of Joining :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "35px" }}>
                              {work.dateOfJoining}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Date of Leaving :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "35px" }}>
                              {work.dateOfLeaving}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={2.5}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Job Profile :&nbsp;
                            </Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "7px" }}>
                              {work.jobProfile} <br />
                            </Typography>
                          </Grid>
                        </Grid>

                      </div>
                    ))}

                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Education Details</span> }]}
                        />
                      </Grid>
                    </Grid>

                    {educationDetails && educationDetails.map((edu, index) => (
                      <div key={index}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                          <MKBadge badgeContent={`Education Details ${index + 1}`} color="secondary" variant="contained" container />
                        </div>
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Education :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "74px" }}>
                              {edu.education}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              University :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "75px" }}>
                              {edu.university}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Course :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "94px" }}>
                              {edu.course}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Specialization :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "48px" }}>
                              {edu.specialization}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Mode of Learning :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "20px" }}>
                              {edu.modeOfLearning}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Grade / Mark (in %) :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "11px" }}>
                              {edu.mark}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              From Year :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "73px" }}>
                              {edu.fromYear}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              To Year :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "94px" }}>
                              {edu.toYear}
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                    ))}

                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Certifications</span> }]}
                        />
                      </Grid>
                    </Grid>

                    {certifications && certifications.map((certificate, index) => (
                      <div key={index}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                          <MKBadge badgeContent={`Certification ${index + 1}`} color="secondary" variant="contained" container />
                        </div>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Certification Name :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "65px" }}>
                              {certificate.certificationName}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Technology :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "116px" }}>
                              {certificate.technology}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={6}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Certification Id :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "94px" }}>
                              {certificate.certificationId}
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Certificate URL :&nbsp;
                            </Typography>
                            {certificate && (
                              <a
                                href={certificate.url.startsWith("http") ? certificate.url : `http://${certificate.url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: "32px", textDecoration: "underline" }}
                              >
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "61px", textDecoration: "underline", color: "blue" }}>
                                  {certificate.url}
                                </Typography>
                              </a>
                            )}
                          </Grid>
                        </Grid>

                        {certificate.certificateNeverExpires === 'true' && (
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={6}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Certificate Never Expires :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "25px" }}>
                                {certificate.certificateNeverExpires === 'true' ? 'Yes' : 'No'}
                              </Typography>
                            </Grid>
                          </Grid>
                        )}

                        {certificate.certificateNeverExpires !== 'true' && (
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={6}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Certification Valid From :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "33px" }}>
                                {certificate.certificationFromYear}
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Certification Valid From :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "35px" }}>
                                {certificate.certificationToYear}
                              </Typography>
                            </Grid>
                          </Grid>
                        )}

                      </div>
                    ))}

                    <div>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Language proficiency</span> }]} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Language</span> }]} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Read</span> }]} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Write</span> }]} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Speak</span> }]} />
                        </Grid>

                        {Object.values(personalDetailsLanguage).map((language, index) => (
                          <React.Fragment key={index}>
                            <Grid item xs={12} md={3} justifyContent="center">
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                {language.language}
                              </Typography>
                            </Grid>
                            <Grid item xs={12} md={3} container justifyContent="center">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={language.read}
                                  />
                                }
                              // label="Read"
                              />
                            </Grid>
                            <Grid item xs={12} md={3} container justifyContent="center">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={language.write}
                                  />
                                }
                              // label="Write"
                              />
                            </Grid>
                            <Grid item xs={12} md={3} container justifyContent="center">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={language.speak}
                                  />
                                }
                              // label="Speak"
                              />
                            </Grid>
                          </React.Fragment>
                        ))}
                      </Grid>
                    </div>

                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Address Details</span> }]} />
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={12}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Address Line 1 :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                          {personalDetailsAddress.addressLine1}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={12}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Address Line 2 :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                          {personalDetailsAddress.addressLine2}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Country :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                          {personalDetailsAddress.country}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          State :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "55px" }}>
                          {personalDetailsAddress.state}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={4} mb={1}>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          City :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "65px" }}>
                          {personalDetailsAddress.city}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text">
                          Pincode :&nbsp;
                        </Typography>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                          {personalDetailsAddress.pincode}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                      <Grid item xs={12}>
                        <Breadcrumbs
                          routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Social Media Details</span> }]}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          LinkedIn URL :&nbsp;
                        </Typography>
                        {socialMedia && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "49px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Facebook URL :&nbsp;
                        </Typography>
                        {socialMedia && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "40px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Twitter URL :&nbsp;
                        </Typography>
                        {socialMedia && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "61px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Instagram URL :&nbsp;
                        </Typography>
                        {socialMedia && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "38px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          GitHub URL :&nbsp;
                        </Typography>
                        {socialMedia && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "61px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).gitHubUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} mb={1}>
                      <Grid item>
                        <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                          Youtube URL :&nbsp;
                        </Typography>
                        {socialMedia && (
                          <a
                            href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginLeft: "5px", textDecoration: "underline" }}
                          >
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "52px", textDecoration: "underline", color: "blue" }}>
                              {JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl}
                            </Typography>
                          </a>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid container justifyContent="center" spacing={2} mt={2} style={{ marginTop: "-40px", marginBottom: "-80px" }}>
                  <Grid item>
                    <MKButton
                      variant="gradient"
                      color="info"
                      size="small"
                      onClick={() => onDeclineClick()}
                      style={{ padding: '5px 10px' }}
                    >
                      Decline
                    </MKButton>
                  </Grid>
                  <Grid item>
                    <MKButton
                      variant="gradient"
                      color="info"
                      size="small"
                      onClick={() => onAcceptClick()}
                      style={{ padding: '5px 10px' }}
                    >
                      Accept
                    </MKButton>
                  </Grid>
                </Grid>
              </Grid>
            </Container>
          </MKBox>
        </Card>
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
            <SimpleFooter />
          </MKBox>
        </div>
      </MKBox>
    </>
  );
}

export default Author;
